// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.
import { ILicense, IVolume } from '../types/subscription';
import { DISCRETE_KEYS, ENCRYPTED_DISCRETE_KEYS } from '../types/d3ePolicy';
import { getKeyIndex } from '../types/key';

export function replaceGuidsWithMountLetters(license: ILicense): ILicense {
    if (!license || !license.config || !license.config.disks) {
      return license;
    }

    try {
      const flattenedVolumes: IVolume[] = getFlattenedVolumes(license);
      for (const [i, key] of DISCRETE_KEYS.entries()) {
        if (license.config.hasOwnProperty(key) && license.config[key].length > 0) {
          for (const [j, path] of license.config[key].entries()) {
            for (const [k, v] of flattenedVolumes.entries()) {
              const newPath = path.replace(v.guid, v.mount + ':');
              if (path !== newPath) {
                license.config[key][j] = newPath;
                break;
              }
            }
          }
        }
      }

      for (const [i, key] of ENCRYPTED_DISCRETE_KEYS.entries()) {
        if (license.config.hasOwnProperty(key) && license.config[key].length > 0) {
          for (const [j, encryptedFolder] of license.config[key].entries()) {
            license.config[key][j].dir = getPathWithMountLetter(encryptedFolder.dir, flattenedVolumes);
            let key_index = getKeyIndex(license.config, key, j, false);
            if ( key_index < 0 ) {
                key_index = getKeyIndex(license.config, key, j, true);
            }
            license.config[key][j].keyIndex = key_index;
          }
        }
      }

    } catch (error) {
      console.error(error);
    }

    return license;
}

export function getFlattenedVolumes(license: ILicense): IVolume[] {
    let flattenedVolumes: IVolume[] = [];

    if (license.config && license.config.disks) {
        flattenedVolumes = license.config.disks.reduce(
            (arr, elem) => {
                if (elem.volumes) {
                    for (const v of elem.volumes) {
                        arr.push(v);
                    }
                }
                return arr;
            }, []
        );
    }
    return flattenedVolumes;
}

export function getPathWithMountLetter(path: string, volumes: IVolume[]): string {
    if (!path) {
        return path;
    }
    path = path.trim().replace('\\\\?\\Volume', '');
    for (const [k, v] of volumes.entries()) {
        // If the volume mount contains null then just return the guid in the path.
        if (v.mount !== '\u0000') {
            const newPath = path.replace(v.guid, v.mount + ':');
            if (path !== newPath) {
                return newPath;
            }
        }
    }
    return path;
}
